<template>
  <div>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title>
          <v-row pt-4>
            <v-file-input
              v-model="file"
              accept=".csv"
              label="Upload .csv file with rates"
            />
            <v-btn
              class="ma-2"
              color="primary"
              :disabled="!isFileCorrect"
              :loading="loadingPreview"
              :dark="isFileCorrect"
              @click="getPreview"
            >
              Get preview
              <v-icon right>
                mdi-file-eye-outline
              </v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1 table"
            multi-sort
            :loading="loadingPreview || loadingUpload"
            item-key="id"
            :item-class="item => colorSchema[item.type] || ''"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Upload preview</v-toolbar-title>
                <v-spacer />
                <FilterInput
                  v-model="filters"
                  :items="searchArray"
                  class="ma-2"
                />
              </v-toolbar>
            </template>
            <template v-slot:item.marginDesired="{ item }">
              <MarginCell
                :margin-desired="item.marginDesired"
                :margin-desired-ranges="item.marginDesiredRanges"
              />
            </template>
            <template v-slot:item.actions="{ item }">
              <div class="d-flex">
                <v-icon
                  small
                  class="mr-2"
                  @click="() => item"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  class="mr-2"
                  @click="() => item"
                >
                  mdi-trash-can
                </v-icon>
              </div>
            </template>
            <template v-slot:no-data />
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="close">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :loading="loadingUpload"
            :disabled="!isFileCorrect"
            :dark="isFileCorrect"
            @click="upload"
          >
            Upload
            <v-icon right>
              mdi-upload
            </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-overlay :value="loadingPreview || loadingUpload">
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-overlay>
    </v-dialog>

    <UploadRateDialog
      :show-rate-dialog="showSuccessFileUpload"
      :rate-dialog-message="successFileUpload"
      @on-close-dialog="onCloseDialog"
    />
  </div>
</template>

<script>
// components
import FilterInput from "@/components/FilterInput";
import MarginCell from "@/components/MarginCell";
import UploadRateDialog from "@/components/dialogs/UploadRateDialog";

// utils
import { autopricingTableUploadPreviewHeaders } from "@/utils/staticTablesColumns";
import { uploadTableColorSchema } from "@/utils/staticAutopricing";

export default {
  name: "UploadRateModal",
  components: {
    FilterInput,
    MarginCell,
    UploadRateDialog
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      file: null,
      filters: [],
      loadingPreview: false,
      loadingUpload: false,
      colorSchema: uploadTableColorSchema,
      headers: autopricingTableUploadPreviewHeaders,
      showSuccessFileUpload: false,
      successFileUpload: null
    };
  },

  computed: {
    searchArray() {
      return this.headers.filter(i => i.sortable !== false);
    },
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    items() {
      return this.$store.getters["RecordStore/getListPreview"].filter(item =>
        this.filters.reduce(
          (acc, filter) => acc && filter.validation(item),
          true
        )
      );
    },
    isFileCorrect() {
      return typeof this.file?.name == "string";
    }
  },

  watch: {
    dialog() {
      this.$set(this, "file", null);
      this.$store.dispatch("RecordStore/clearPreviewList");
    }
  },

  methods: {
    onCloseDialog() {
      this.showSuccessFileUpload = false;
      this.successFileUpload = {};
      this.close();
    },
    getPreview() {
      this.loadingPreview = true;
      this.$store
        .dispatch("RecordStore/previewCsv", this.getFormData())
        .finally(() => (this.loadingPreview = false));
    },
    upload() {
      this.loadingUpload = true;
      this.$store
        .dispatch("RecordStore/uploadCsv", this.getFormData())
        .then(response => {
          this.showSuccessFileUpload = true;
          this.successFileUpload = response.data;
          this.$emit("upload", this.copyOfRate);
        })
        .finally(() => (this.loadingUpload = false));
    },
    getFormData() {
      let formData = new FormData();
      formData.append("csvFile", this.file, this.file.name);
      return formData;
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>
